import type { FunctionComponent, ReactElement } from 'react';

import { useMcpOptionalSitesFlow } from './useMcpConsentFlow';
import McpConsentLayout from '../MCP/McpConsentLayout';
import OptionalSitesConsentLayout from './McpConsentLayout';

/**
 * The MCP context provider, consent screen and footer for the flow the
 * MCP_OPTIONAL_SITES gate selects. See useMcpOptionalSitesFlow.
 *
 * Kept separate from McpFlowParametersSwitch so that neither seam pulls the
 * other's module graph in — FlowParameters is imported by every consent flow,
 * and the layouts bring a Relay query with them.
 */
const McpConsentLayoutSwitch: FunctionComponent = (): ReactElement =>
  useMcpOptionalSitesFlow() ? (
    <OptionalSitesConsentLayout />
  ) : (
    <McpConsentLayout />
  );

export default McpConsentLayoutSwitch;
